<template>
  <a-menu
    class="inner-menu"
    mode="inline"
    :openKeys="openKeys || openKeysData"
    :selectedKeys="selectedKeys || selectedKeysData"
    @openChange="openKeys => openKeysData = openKeys.slice(-1)"
  >
    <template v-for="mainItem in menu">
      <template v-if="!mainItem.hiddenInMenu">
        <a-sub-menu
          v-if="!mainItem.hideChildrenInMenu && mainItem.children && mainItem.children.length"
          :key="mainItem.name"
        >
          <span slot="title">
            <a-icon :type="mainItem.meta.icon" />
            <span>{{mainItem.meta.title}}</span>
          </span>
          <template v-for="subItem in mainItem.children">
            <a-menu-item
              v-if="!subItem.hiddenInMenu"
              :key="subItem.name"
              class="inner-menu__item"
            >
              <router-link :to="subItem.path">{{subItem.meta.title}}</router-link>
            </a-menu-item>
          </template>
        </a-sub-menu>
        <a-menu-item
          v-else
          class="inner-menu__item"
          :key="mainItem.name"
        >
          <router-link :to="mainItem.path">
            <a-icon :type="mainItem.meta.icon" />
            <span>{{mainItem.meta.title}}</span>
          </router-link>
        </a-menu-item>
      </template>
    </template>
  </a-menu>
</template>

<script>
export default {
  name: 'InnerMenu',
  props: {
    menu: {
      type: Array,
      required: true,
    },
    openKeys: {
      type: Array,
      default() {
        return undefined;
      },
    },
    selectedKeys: {
      type: Array,
      default() {
        return undefined;
      },
    },
  },
  data() {
    return {
      // 展开的菜单项
      openKeysData: [],
      // 选中的菜单项
      selectedKeysData: [],
    };
  },
  watch: {
    $route() {
      this.updateMenu();
    },
  },
  created() {
    this.updateMenu();
  },
  methods: {
    updateMenu() {
      let routes = this.$route.matched.concat();
      if (routes && routes.length) {
        const menuDeep = 2;
        routes = routes.splice(1, menuDeep);
        if (routes.length >= menuDeep) {
          const routeName = routes.slice(-2)[0].name;
          this.openKeysData = [routeName];
          this.selectedKeysData = [routeName];
        }
        if (routes.length >= menuDeep - 1) {
          this.selectedKeysData = [routes.slice(-1)[0].name];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.inner-menu {
  width: 200px;
  border-right: none;
  border-radius: @border-radius-base;
  box-shadow: @box-shadow-base;

  /deep/ .ant-menu {
    &-item,
    &-submenu-title {
      width: 100%;
      margin: 0;
      font-size: 16px;
    }

    &-item {
      &:after {
        display: none;
      }
    }

    &-submenu-title {
      height: 60px;
      line-height: 60px;
      padding-left: 20px !important;

      .anticon {
        margin-right: @padding-sm;
        font-size: 16px;
      }
    }
  }

  &__item {
    height: 48px !important;
    line-height: 48px !important;
  }
}
</style>
